import React from 'react';
import { BookOpenIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
type BenefitProps = {
  icon: React.ElementType;
  text: string;
  className?: string;
};
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="my-12 rounded-[2rem] border border-brand-gold/45 bg-brand-paper/70 shadow-[0_20px_55px_rgba(76,50,79,0.11)]" data-id="element-255" data-mp="1vutijibz4pdd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-256" data-mp="25shkotbwsz5k">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-purple px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-257" data-mp="25pv4k5aydbbq">
          <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-258" data-mp="3h5tionkzmnjt" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-259" data-mp="3cae5zyypuxoz">
          TU <span className="text-brand-purple" data-id="element-260" data-mp="3vz6xzp9gm9ls">MEGA PACK REIKI™</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-261" data-mp="4rkqtmnj7p06">
          El precio de lanzamiento cierra pronto. Después sube $20.000 ARS.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-262" data-mp="erv2h2tx4od8">
        <div className="rounded-3xl border-2 border-brand-gold/65 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(139,105,55,0.14)] md:p-7" data-id="element-263" data-mp="eqjzh58arkn6">
          <div className="flex items-center gap-2 text-brand-goldDark" data-id="element-264" data-mp="3i7sg5lragegb">
            <TrophyIcon className="h-4 w-4" data-id="element-265" data-mp="3i5picfjw9h11" />
            <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-266" data-mp="3n6vfcpkl7qgd" />
            <span className="text-[10px] font-bold uppercase tracking-[0.16em] md:text-xs" data-id="element-267" data-mp="3rxv8djql5odl">
              El sistema más completo para tu consulta Reiki
            </span>
          </div>
          <div className="mt-4 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-268" data-mp="2ugd8ddgqt4xo">
            <div data-id="element-269" data-mp="2zfg427au1ysz">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-270" data-mp="2rguzhcxrzud7">MEGA PACK REIKI™</h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-271" data-mp="2mhrufshspo58">3 Tomos + 6 Bonos · 270 páginas de contenido profesional</p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-272" data-mp="3177iv1tuthhr">
                El ecosistema definitivo para terapeutas que quieren dejar de improvisar y llevar su práctica al siguiente nivel.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-273" data-mp="28k3aqnzgsn1r">
              <p className="text-sm text-brand-muted line-through" data-id="element-274" data-mp="23jz0hfp5gojz">$95.000 ARS</p>
              <p className="font-serif text-3xl font-bold text-brand-purple" data-id="element-275" data-mp="2iggd0a92s984">$24.990 ARS</p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-276" data-mp="2dfsc8wv1oe0p">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-277" data-mp="3ovz5ldood7n5">
            → QUIERO MI MEGA PACK REIKI™ $24.990
          </CTAButton>
        </motion.div>
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-5" aria-label="Beneficios de compra" data-id="element-278" data-mp="59zyz22tbdsv">
          <Benefit icon={BookOpenIcon} text="Listo para imprimir o usar en tablet" data-id="element-279" data-mp="3nflf4pk3o8l9" />
          <Benefit icon={LockKeyholeIcon} text="Pago seguro" data-id="element-280" data-mp="3rgeyd5mlkz7t" />
          <Benefit icon={CreditCardIcon} text="Mercado Pago" data-id="element-281" data-mp="3rgyfwl8c5llb" />
          <Benefit icon={DownloadIcon} text="100% PDF" data-id="element-282" data-mp="j1wlmqlpovhv" />
          <Benefit icon={ZapIcon} text="Acceso inmediato" className="col-span-2 sm:col-span-1" data-id="element-283" data-mp="nzyge8si2j96" />
        </div>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-284" data-mp="a8tbosa9z0rz">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 text-brand-purple" data-id="element-285" data-mp="a6gx8p3q78jo" />
          Garantía de 7 días
        </p>
      </div>
    </Section>;
}
function Benefit({
  icon: Icon,
  text,
  className = ''
}: BenefitProps) {
  return <div className={`flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-purple/20 bg-brand-paper px-2 py-2 text-center ${className}`} data-id="element-286" data-mp="16q7jdkw42f1x">
      <Icon className="h-4 w-4 text-brand-purple" aria-hidden="true" data-id="element-287" data-mp="3f55t941rq9yb" />
      <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-288" data-mp="3a6uk6vjas3h5">{text}</span>
    </div>;
}